var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('dx-external-lawyer-registration',{attrs:{"invitation-token":_vm.$route.query.invitationToken}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }